import { RoleType } from "@/typedefs/user";
import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getAllAdminUsers({
  page = 1,
  pageSize = 10,

  city,
  state,
  verified,
  hasTWIC,
  hasEModal,
  isActive,
  isShared,
  userType,
  filter = "",
  roleId,
  organizationUnitId,
  userName,
  phoneNumber,
  email,
  firstName,
  lastName,
  isLockedOut,
  notActive,
  emailConfirmed,
  isExternal,
  maxCreationTime,
  minCreationTime,
  maxModificationTime,
  minModificationTime,
  sorting,
  tagIds,
}) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount,

    City: city,
    State: state,
    IsVerified: verified,
    HasTwic: hasTWIC,
    HasEModal: hasEModal,
    IsActive: isActive,
    IsShared: isShared,
    Type: userType,
    Filter: filter || undefined,
    RoleId: roleId,
    OrganizationUnitId: organizationUnitId,
    UserName: userName,
    PhoneNumber: phoneNumber,
    EmailAddress: email,
    Name: firstName,
    Surname: lastName,
    IsLockedOut: isLockedOut,
    NotActive: notActive,
    EmailConfirmed: emailConfirmed,
    IsExternal: isExternal,
    MaxCreationTime: maxCreationTime,
    MinCreationTime: minCreationTime,
    MaxModifitionTime: maxModificationTime,
    MinModifitionTime: minModificationTime,
    Sorting,
    TagIds: tagIds,
  });

  try {
    const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
      method: "GET",
      params,
    });
    return result?.data;
  } catch (error) {
    return {
      items: [],
      totalCount: 0,
    };
  }
}

export async function createNewAdminUser(userData) {
  const data = {
    ...userData,
    type: RoleType.Admin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getAdminUserById(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin/${userId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function updateAdminUser(userId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/admin`, {
    method: "PUT",
    params: { id: userId },
    data,
  });

  if ("error" in result) {
    throw new Error(result.error.message);
  }

  return result?.response?.ok;
}

export async function updateProfilePhoto({ userId, profilePhotoUri }) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/${userId}/profile-photo`, {
    method: "PATCH",
    params: {
      profilePhotoUri,
    },
  });

  return result?.data;
}
export async function getAdminManagers({ filter = "" }) {
  const params = cleanObjectFromUndefined({
    FilterText: filter || undefined,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/managers`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getManagerById(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/managers/${userId}`, {
    method: "GET",
  });

  return result?.data;
}
